import React from 'react'
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material'

const FacebookIcon = (props: SvgIconProps) => {
  // @ts-ignore
  const { color, fill, stroke, sx, width, height, ...otherProps } = props // eslint-disable-line
  const theme = useTheme()

  let selectedColor = color

  // @ts-ignore
  if (color && theme.palette[color]) {
    // @ts-ignore
    selectedColor = theme.palette[color].main
  }

  const fillStyle = fill || selectedColor || undefined

  const styles = {
    width: 'inherit',
    height: 'inherit',
    fill: 'inherit',
    ...sx,
  }

  const cleanedPaths = () => (
    <svg
      width={width || 48}
      height={height || 48}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M41.25 5.25H6.75C5.92031 5.25 5.25 5.92031 5.25 6.75V41.25C5.25 42.0797 5.92031 42.75 6.75 42.75H41.25C42.0797 42.75 42.75 42.0797 42.75 41.25V6.75C42.75 5.92031 42.0797 5.25 41.25 5.25ZM36.9187 16.1953H33.9234C31.575 16.1953 31.1203 17.3109 31.1203 18.9516V22.5656H36.7266L35.9953 28.2234H31.1203V42.75H25.275V28.2281H20.3859V22.5656H25.275V18.3937C25.275 13.5516 28.2328 10.9125 32.5547 10.9125C34.6266 10.9125 36.4031 11.0672 36.9234 11.1375V16.1953H36.9187Z"
        fill={fillStyle || '#2B2E31'}
      />
    </svg>
  )

  return (
    <SvgIcon
      component={cleanedPaths}
      inheritViewBox
      sx={styles}
      {...otherProps}
    />
  )
}

export default FacebookIcon
